import datos from "src/services/datos";
import { postCuentas } from "../cuentas/helpers/CuentasData";
import { postCuentasCategoriaCuentas } from "../cuentas/helpers/CuentasCategoriaCuentas";
import { esArray } from "src/general_components/functionEsArray";

export const getCuentasJuridicas = async (cuentas,genericas) => {
  
  const objectCuentasJuridicas = new datos("cuentas_personas_juridicas");
  let condicionIn = ''
  genericas===true?condicionIn='in':condicionIn='not in';
  // Filtro por cuentas vinculadas al usuario
  if (cuentas) {
    let listIdCuenta = cuentas.map((cuenta) => cuenta.id_cuentas);
    objectCuentasJuridicas.addCondition(
      "cuentas_personas_juridicas",
      "id_cuentas",
      listIdCuenta,
      condicionIn
    );
  }
  objectCuentasJuridicas.addCondition(
    "cuentas_personas_juridicas",
    "id",
    0,
    ">"
  );

  const response = await objectCuentasJuridicas.get();
  const res = esArray(response.wsResponse.cuentas_personas_juridicas);

  return res;
};

export const getCuentasJuridicasByIdCuenta = async (id) => {
  const objectCuentasJuridicas = new datos("cuentas_personas_juridicas");

  objectCuentasJuridicas.addCondition(
    "cuentas_personas_juridicas",
    "id_cuentas",
    id,
    "="
  );

  const response = await objectCuentasJuridicas.get();

  if (response) {
    return [...response.wsResponse.cuentas_personas_juridicas];
  }
  return response;
};

export const postCuentasJuridicas = async (CuentaJuridica, CategoriaCuenta) => {
  const { id, razon_social, nombre_fantasia } = CuentaJuridica;

  if (/*!juridica_idcuenta ||*/ !razon_social || !nombre_fantasia) {
    return;
  }

  const objetoCuentasJuridicas = new datos("cuentas_personas_juridicas");

  if (!id) {
    const cuenta = {
      es_owner: "0",
    };
    const response = await postCuentas(cuenta);
    if (response.wsResponse.cuentas > 0) {
      const cuenta_aux = { ...CuentaJuridica };
      cuenta_aux.id_cuentas = response.wsResponse.cuentas;
      const categoriaCuenta_aux = { ...CategoriaCuenta };
      categoriaCuenta_aux.id_cuentas = response.wsResponse.cuentas;
      const response2 = await postCuentasCategoriaCuentas(categoriaCuenta_aux);
      if (response2.wsResponse.cuentas_categoria_cuentas > 0) {
        const response3 = await objetoCuentasJuridicas.insert(cuenta_aux);
        return response3;
      } else return response2;
    } else return response;
  }
  await postCuentasCategoriaCuentas(CategoriaCuenta);
  return await objetoCuentasJuridicas.insert(CuentaJuridica);
};

export const deleteCuentasJuridicas = async (id) => {
};
